module.exports = __webpack_public_path__ + "assets/align-to-middle-icon.0dfe878e.svg";